const cards = [
  {
    id: 1,
    tag: '热帖',
    tagColor: 'bg-primary-500',
    title: '某男星深夜与神秘女子进出酒店，这是第几个了？',
    excerpt: '据目击者称，两人举止亲密，逗留约三小时后先后离开。该男星此前已被拍到与多名女性关系密切。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20outside%20luxury%20hotel%20entrance%20with%20warm%20golden%20lighting%2C%20silhouettes%20of%20people%2C%20paparazzi-style%20street%20photography%20aesthetic%2C%20warm%20amber%20and%20dark%20tones%2C%20editorial%20urban%20night%20atmosphere&width=600&height=400&seq=cards-post-01&orientation=landscape',
    time: '2小时前',
    views: '89万',
  },
  {
    id: 2,
    tag: '热议',
    tagColor: 'bg-accent-500',
    title: '综艺节目剪辑有猫腻？选手发文控诉自己被恶意剪辑',
    excerpt: '该选手在社交平台发布长文，详细列举节目组恶意剪辑的多个证据，引发粉丝群体激烈讨论。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20TV%20editing%20room%20scene%20with%20multiple%20monitors%20showing%20different%20angles%2C%20warm%20studio%20lighting%2C%20film%20editing%20equipment%2C%20professional%20atmosphere%20in%20warm%20golden%20and%20amber%20tones&width=600&height=400&seq=cards-post-02&orientation=landscape',
    time: '3小时前',
    views: '67万',
  },
  {
    id: 3,
    tag: '新帖',
    tagColor: 'bg-secondary-500',
    title: '电商大促数据造假？内部员工匿名曝光刷单全流程',
    excerpt: '自称某头部电商前员工的网友发帖，详细描述平台如何在大促期间系统性地操纵销量数据。',
    img: 'https://readdy.ai/api/search-image?query=A%20suspicious%20e-commerce%20data%20dashboard%20with%20manipulated%20numbers%2C%20warm%20office%20lighting%2C%20computer%20screen%20glow%2C%20whistleblower%20atmosphere%2C%20warm%20amber%20tones%2C%20investigative%20journalism%20aesthetic&width=600&height=400&seq=cards-post-03&orientation=landscape',
    time: '5小时前',
    views: '54万',
  },
  {
    id: 4,
    tag: '热帖',
    tagColor: 'bg-primary-500',
    title: '女星整容前后对比图流出，网友：根本认不出来',
    excerpt: '一组据称是某当红女星出道前的旧照在网上疯传，与现在的外貌差异巨大，引发整容质疑。',
    img: 'https://readdy.ai/api/search-image?query=A%20split%20before-and-after%20comparison%20illustration%20with%20contrasting%20halves%2C%20fashion%20magazine%20aesthetic%2C%20warm%20studio%20portrait%20lighting%2C%20glamorous%20atmosphere%20in%20warm%20rose%20and%20gold%20tones&width=600&height=400&seq=cards-post-04&orientation=landscape',
    time: '6小时前',
    views: '127万',
  },
  {
    id: 5,
    tag: '热议',
    tagColor: 'bg-accent-500',
    title: '知名导演新片选角黑幕曝光：投资方内定女主角',
    excerpt: '多位试镜演员联合发声，称最终人选早在试镜前就已内定，公开选角纯属走过场。',
    img: 'https://readdy.ai/api/search-image?query=A%20film%20casting%20audition%20room%20scene%20with%20empty%20chairs%20and%20spotlight%2C%20theatrical%20dramatic%20lighting%2C%20backstage%20atmosphere%2C%20warm%20golden%20stage%20light%2C%20minimal%20editorial%20photography%20style&width=600&height=400&seq=cards-post-05&orientation=landscape',
    time: '8小时前',
    views: '73万',
  },
  {
    id: 6,
    tag: '新帖',
    tagColor: 'bg-secondary-500',
    title: '音乐节假唱风波升级：业内人士揭露现场音频造假技术',
    excerpt: '一位自称从业十年的调音师匿名爆料，揭露大型音乐节现场如何通过各种技术手段掩盖假唱。',
    img: 'https://readdy.ai/api/search-image?query=A%20music%20festival%20stage%20with%20audio%20equipment%20and%20mixing%20console%20silhouettes%2C%20dramatic%20concert%20lighting%2C%20crowd%20in%20distance%2C%20warm%20amber%20and%20golden%20stage%20lights%2C%20editorial%20music%20photography%20style&width=600&height=400&seq=cards-post-06&orientation=landscape',
    time: '10小时前',
    views: '41万',
  },
  {
    id: 7,
    tag: '热帖',
    tagColor: 'bg-primary-500',
    title: '偶像团体成员被曝私下恋爱多年，粉丝后援会集体脱粉',
    excerpt: '有网友整理了大量时间线证据，证明该偶像与圈外女友已交往超过三年，粉丝反应两极分化。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20candlelit%20secret%20date%20scene%20silhouette%2C%20warm%20intimate%20lighting%2C%20hidden%20relationship%20atmosphere%2C%20soft%20focus%20romantic%20photography%2C%20warm%20rose%20and%20golden%20tones%2C%20editorial%20style&width=600&height=400&seq=cards-post-07&orientation=landscape',
    time: '12小时前',
    views: '156万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                热门帖子
              </h2>
              <p className="text-sm text-foreground-500">全网最火爆料帖，实时更新中</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cards.map((card) => (
              <article
                key={card.id}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 hover:-translate-y-1 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className={`absolute top-3 left-3 px-2 py-0.5 ${card.tagColor} text-white text-xs font-medium rounded`}>
                    {card.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {card.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{card.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {card.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}